'use strict';
Object.defineProperty(exports, '__esModule', { value: true });
var prefix = 'fadt';
var iconName = 'arrow-up';
var width = 384;
var height = 512;
var aliases = [8593];
var unicode = 'f062';
var svgPathData = ['', 'M197.8 34.5c-1.5-1.6-3.6-2.5-5.8-2.5s-4.3 .9-5.8 2.5l-184 192c-3.1 3.2-2.9 8.3 .2 11.3s8.3 2.9 11.3-.2L184 59.9 184 472c0 4.4 3.6 8 8 8s8-3.6 8-8l0-412.1L370.2 237.5c3.1 3.2 8.1 3.3 11.3 .2s3.3-8.1 .2-11.3l-184-192z'];

exports.definition = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    aliases,
    unicode,
    svgPathData
  ]};

exports.faArrowUp = exports.definition;
exports.prefix = prefix;
exports.iconName = iconName;
exports.width = width;
exports.height = height;
exports.ligatures = aliases;
exports.unicode = unicode;
exports.svgPathData = svgPathData;
exports.aliases = aliases;